import { defineComponent } from 'vue'
import { ClientOnly, GfrButton, GfrScrollArea, IconsDesktop, IconsMobile } from '#components'
type BlocklyType = 'fe' | 'cl' | 'none'
export default defineComponent({
  name: 'MarkdownBlockly',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const blocklyRef = ref<HTMLElement>()
    const blockly = ref<any>()
    const route = useRoute()
    const blocklyType = ref<BlocklyType>()
    const blocklyTypes = computed(() => {
      return Object.keys(props.data) as BlocklyType[]
    })
    const blocklyTypeIndex = computed(() => {
      return blocklyTypes.value.findIndex((t) => t === blocklyType.value)
    })
    function toggleBlocklyType(type: BlocklyType) {
      blocklyType.value = type
    }
    async function initBlockly(type: BlocklyType) {
      const { $blockly } = useNuxtApp()
      const defaultBlocklyLang = import.meta.env.VITE_BLOCKLY_DEFAULT_LANG
      const lang = route.params.lang === 'en' && defaultBlocklyLang === 'en-in' ? 'en-in' : route.params.lang
      const blocklyData = type === 'none' ? props.data : props.data[type]
      const isCraftland = type === 'cl'
      // $blockly 现在是异步函数，需要先加载 Blockly 模块
      const loadBlocklyState = await $blockly()
      if (blocklyRef.value) {
        setTimeout(async () => {
          // TODO： 优化 - 等待 DOM 元素准备好
          blockly.value = await loadBlocklyState(
            blocklyRef.value,
            blocklyData || {},
            lang || defaultBlocklyLang,
            isCraftland
          )
        }, 100)
      }
    }
    watch(
      () => blocklyType.value,
      async () => {
        await nextTick()
        if (blocklyRef.value) {
          if (blockly.value?.dispose) {
            blockly.value.dispose()
          }
          await initBlockly(blocklyType.value as BlocklyType)
        }
      }
    )
    onMounted(async () => {
      await nextTick()
      try {
        if (!blocklyTypes.value.includes('cl') && !blocklyTypes.value.includes('fe')) {
          toggleBlocklyType('none')
        } else {
          toggleBlocklyType(blocklyTypes.value.includes('cl') ? 'cl' : 'fe')
        }
      } catch (error) {
        console.error(error)
      }
    })
    onUnmounted(() => {
      if (blockly.value) {
        blockly.value.dispose()
      }
    })
    return () => (
      <ClientOnly>
        <div class={'app-markdown-blockly-inner flex justify-between'}>
          <GfrScrollArea
            class="flex-1 pb-4 mr-4 inline-flex"
            direction="horizontal"
            dir={route.params.lang === 'ar' ? 'rtl' : 'ltr'}
          >
            <div ref={blocklyRef} class={'app-markdown-blockly'} />
          </GfrScrollArea>
          {blocklyType.value !== 'none' && (
            <div
              class="app-markdown-blockly-toggle flex-shrink-0 relative z-10 flex items-center p-0.5 bg-dark-background rounded-[2px] h-8 max-lg:h-11"
              style={{
                direction: 'ltr'
              }}
            >
              {blocklyTypes.value.map((type) => (
                <GfrButton
                  class={`w-8 h-7 max-lg:h-10 max-lg:w-11 `}
                  onClick={() => toggleBlocklyType(type as 'fe' | 'cl')}
                >
                  {type === 'fe' ? (
                    <IconsDesktop
                      class={`max-lg:w-8 max-lg:h-8 ${blocklyType.value === type ? 'text-dark' : 'text-light'} transition-colors duration-300`}
                    />
                  ) : (
                    <IconsMobile
                      class={`max-lg:w-8 max-lg:h-8 ${blocklyType.value === type ? 'text-dark' : 'text-light'} transition-colors duration-300`}
                    />
                  )}
                </GfrButton>
              ))}
              <div
                v-show={blocklyTypeIndex.value >= 0}
                class="bg-primary absolute top-0.5 left-0.5 -z-10 w-8 h-7 max-lg:h-10 max-lg:w-11 transition-transform duration-300 rounded-[2px]"
                style={{
                  transform: `translateX(${blocklyTypeIndex.value * 100}%)`
                }}
              />
            </div>
          )}
        </div>
      </ClientOnly>
    )
  }
})
